import { render, staticRenderFns } from "./MtSalesImport.vue?vue&type=template&id=c84f3df4&scoped=true&"
import script from "./MtSalesImport.vue?vue&type=script&lang=js&"
export * from "./MtSalesImport.vue?vue&type=script&lang=js&"
import style0 from "./MtSalesImport.vue?vue&type=style&index=0&id=c84f3df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84f3df4",
  null
  
)

export default component.exports